export const environment: any = {
  production: true,
  staging: false,
  apiUrl: 'https://biznis-api.gov.me/v1',
  baseApiUrl: 'https://biznis-api.gov.me',
  websiteUrl: 'https://biznis.gov.me',
  mediaUrl: 'https://media-api.fleka.me/media/'
};
